import { useRef } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import Carousel from '@comp/Carousel/Carousel';

import { segment } from '@actions/analytics';
import { SYLLABUS_SEE_ALL_CLICKED } from '@constants/segment';
import LessonCard from '@comp/LessonCard/LessonCard';
import { Spacings } from '@styles/index';
import useGoalEventProps from '@hooks/useGoalEventProps';

const LessonsFeedBlock = ({
  lessonsFeedBlock,
  viewAllLink,
  viewAllHref,
  type,
  topic,
  dataAnalytics,
  lastPrimarySource,
  goalUID
}) => {
  const viewRef = useRef();
  const { label } = lessonsFeedBlock;
  const goalProps = useGoalEventProps({ goalUID });

  const RenderPlusCourseCards = () =>
    lessonsFeedBlock.data.map((courseData, _index) => (
      <LessonCard
        label={label}
        index={_index}
        lastPrimarySource={lastPrimarySource}
        key={courseData.uid}
        lesson={courseData}
        type={type}
        topic={topic}
        dataAnalytics={dataAnalytics}
        goalUID={goalUID}
      />
    ));

  const seeAllClickEvent = () => {
    segment.track(SYLLABUS_SEE_ALL_CLICKED, {
      expansion_type: lessonsFeedBlock.label,
      last_primary_source: lastPrimarySource,
      last_primary_source_section: lessonsFeedBlock.label,
      ...goalProps
    });
  };

  return (
    <>
      <Carousel
        label={label}
        seeAllLink={viewAllLink}
        href={viewAllHref}
        dataAnalytics="goal-course"
        ref={viewRef}
        handleClickSeeAll={seeAllClickEvent}
        $css={css`
          margin-bottom: ${Spacings.SPACING_14B};
        `}
      >
        {RenderPlusCourseCards()}
      </Carousel>
    </>
  );
};

LessonsFeedBlock.propTypes = {
  viewAllLink: PropTypes.string.isRequired,
  viewAllHref: PropTypes.string.isRequired,
  lessonsFeedBlock: PropTypes.objectOf(PropTypes.unknown).isRequired,
  type: PropTypes.string.isRequired,
  topic: PropTypes.objectOf(PropTypes.unknown),
  dataAnalytics: PropTypes.string,
  lastPrimarySource: PropTypes.string
};

LessonsFeedBlock.defaultProps = {
  topic: undefined,
  dataAnalytics: '',
  lastPrimarySource: ''
};

export default LessonsFeedBlock;
